export default __webpack_public_path__ + "static/media/login-page-background.ce8e578b.jpg";